import React from 'react';

import styled from 'styled-components';

import { useCurrentProject } from '@adsk/alloy-provider';
import A from '@adsk/alloy-react-a';
import { ActivityCard } from '@adsk/alloy-react-activity-log';
import StatusColorIndicator from '@adsk/alloy-react-status-color-indicator';
import Theme from '@adsk/alloy-react-theme';
import { OverflowTooltip } from '@adsk/alloy-react-tooltip';

import { useCostContext } from './CostProvider';
import { useTranslation } from './i18n';
import { ACTIVITY_VARIANTS } from '../../constants';
import {
  getStatus,
  STATUS_COLOR_MAPPING,
  shouldShowStatus,
  MAPPING_KEY,
} from '../helpers/consts';
import { getDeepLink } from '../helpers/formatEntities';
import { customizedType } from '../helpers/localeHelper';

const StyledContentContainer = styled.div`
  display: flex;
  align-items: center;
  ${Theme.typography.bodyMediumBold}
  ${Theme.typography.ellipsis}
`;

const StyledStatusContainer = styled.div`
  ${Theme.typography.heading5};
  ${Theme.typography.ellipsis};
  display: flex;
  align-items: center;
  margin-top: 6px;
`;

const StyledStatusColorIndicator = styled(StatusColorIndicator)`
  height: 16px;
  width: 3px;
  cursor: default;
`;

const CostActivityCard = ({ entity, variant, type = '', ...rest }) => {
  const { name } = entity;
  const { t } = useTranslation();
  const project = useCurrentProject();
  const { terminologies } = useCostContext();

  const status = getStatus(type, entity);

  return (
    <ActivityCard
      {...rest}
      title={
        variant === ACTIVITY_VARIANTS.REMOVED
          ? t('ACTIVITY_TITLE_REMOVED', {
              type: customizedType(t, type, terminologies),
            })
          : t('ACTIVITY_TITLE_ADDED', {
              type: customizedType(t, type, terminologies),
            })
      }
    >
      <StyledContentContainer>
        <A
          style={{ marginRight: '5px' }}
          target="__blank"
          href={getDeepLink(entity, project, type)}
        >
          {entity[MAPPING_KEY[type]]}
        </A>
        <OverflowTooltip
          content={name}
          singleLine
          getTargetProps={() => ({
            style: { overflow: 'hidden', flex: 1 },
          })}
        >
          {name}
        </OverflowTooltip>
      </StyledContentContainer>

      {shouldShowStatus(type) && (
        <StyledStatusContainer>
          <StyledStatusColorIndicator
            statusColor={STATUS_COLOR_MAPPING[status]}
          />
          <span style={{ marginLeft: '5px' }}>
            {status ? customizedType(t, status, terminologies) : null}
          </span>
        </StyledStatusContainer>
      )}
    </ActivityCard>
  );
};

export default CostActivityCard;
